import { Select, type SelectOption } from "@/components/ui/Select";
import { DatePicker } from "@/components/ui/DatePicker";

export const REPORT_TYPES: SelectOption[] = [
  { value: "demographics", label: "Client Demographics" },
  { value: "client-list", label: "Client List" },
  { value: "activities", label: "Activities / Units of Service" },
  { value: "bednights", label: "Bednight / Occupancy" },
  { value: "departures", label: "Departures" },
  { value: "legal", label: "Legal / Court Advocacy" },
  { value: "turnaways", label: "Turnaways" },
  { value: "meals", label: "Meals" },
  { value: "outcomes", label: "Outcomes" },
  { value: "referrals", label: "Referrals" },
];

const PERSON_TYPES: SelectOption[] = [
  { value: "", label: "All Record Types" },
  { value: "shelter", label: "Adult Shelter" },
  { value: "child", label: "Child Shelter" },
  { value: "outreach", label: "Outreach" },
  { value: "hotline", label: "Hotline" },
];

export interface ReportFilterValues {
  reportType: string;
  dateFrom: string;
  dateTo: string;
  personType: string;
}

interface ReportFiltersProps {
  values: ReportFilterValues;
  onChange: (values: ReportFilterValues) => void;
}

export function ReportFilters({ values, onChange }: ReportFiltersProps) {
  function update(patch: Partial<ReportFilterValues>) {
    onChange({ ...values, ...patch });
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <Select
        label="Report Type"
        options={REPORT_TYPES}
        value={values.reportType}
        onChange={(v) => update({ reportType: v })}
        required
      />
      <DatePicker
        label="From Date"
        value={values.dateFrom}
        onChange={(v) => update({ dateFrom: v })}
      />
      <DatePicker
        label="To Date"
        value={values.dateTo}
        onChange={(v) => update({ dateTo: v })}
      />
      <Select
        label="Record Type"
        options={PERSON_TYPES}
        value={values.personType}
        onChange={(v) => update({ personType: v })}
        clearable
      />
    </div>
  );
}
